import { Directive } from '@angular/core';
import { isObjectEmpty } from 'src/app/_helpers/utils';
import { BusinessTechnicalInstallationInsuranceMetadata } from 'src/app/_types/lead.types';
import { getBusinessMachineCoverLabel } from 'src/app/enums/business/business-machine-cover.enum';
import { getBusinessMachineGroupLabel } from 'src/app/enums/business/business-machine-group.enum';
import { getBusinessWaitingDaysLabel } from 'src/app/enums/business/business-waiting-days.enum';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class BusinessTechnicalInstallationMetadataComponentAbstract extends BaseMetadataComponent<BusinessTechnicalInstallationInsuranceMetadata> {
  getBooleanLabel = getBooleanLabel;

  getBusinessMachineCoverLabel = getBusinessMachineCoverLabel;

  getBusinessMachineGroupLabel = getBusinessMachineGroupLabel;

  getBusinessWaitingDaysLabel = getBusinessWaitingDaysLabel;

  hasMachinesInsuranceMetadata(): boolean {
    const meta = this.metadata?.machinesInsuranceMetadata;
    if (!meta) return false;
    return (
      meta.machinesInsured !== undefined ||
      !this.isObjectEmpty(meta.firstTypeMachineCoverage) ||
      !this.isObjectEmpty(meta.secondTypeMachineCoverage) ||
      !this.isObjectEmpty(meta.lossCoverage) ||
      !this.isObjectEmpty(meta.additionalFeesCoverage) ||
      meta.complementaryCoverage !== undefined ||
      !this.isObjectEmpty(meta.toolsMoldsCoverage) ||
      !this.isObjectEmpty(meta.dataCarriersCoverage) ||
      !this.isObjectEmpty(meta.furniturePiecesCoverage) ||
      !this.isObjectEmpty(meta.additionalConstructionServicesCoverage) ||
      !this.isObjectEmpty(meta.rescueCostsCoverage) ||
      !this.isObjectEmpty(meta.internalDisturbancesDamageCoverage) ||
      meta.undergroundInaccessibilityCoverage !== undefined ||
      !this.isObjectEmpty(meta.fireNaturalDisasterCoverage) ||
      !this.isObjectEmpty(meta.theftCoverage) ||
      !this.isObjectEmpty(meta.replacementCostCoverage)
    );
  }

  hasTechnicalInstallationInsuranceMetadata(): boolean {
    const meta = this.metadata?.technicalInstallationInsuranceMetadata;
    if (!meta) return false;
    return (
      meta.technicalInstallationsInsured !== undefined ||
      !this.isObjectEmpty(meta.computerObjectsCoverage) ||
      !this.isObjectEmpty(meta.technicalInstallationCoverage) ||
      meta.complementaryCoverage !== undefined ||
      !this.isObjectEmpty(meta.dataCarriersCoverage) ||
      !this.isObjectEmpty(meta.computerObjectsInSwitzerlandCoverage) ||
      !this.isObjectEmpty(meta.computerObjectsInternationalCoverage) ||
      !this.isObjectEmpty(meta.wiringCoverage) ||
      !this.isObjectEmpty(meta.additionalConstructionServicesCoverage) ||
      !this.isObjectEmpty(meta.computerObjectsAdditionalFeesCoverage) ||
      meta.cyberCoverage !== undefined ||
      !this.isObjectEmpty(meta.internalDisturbancesDamageCoverage) ||
      !this.isObjectEmpty(meta.undergroundInaccessibilityCoverage) ||
      meta.fireNaturalDisasterCoverageExcluded !== undefined ||
      !this.isObjectEmpty(meta.theftCoverage) ||
      !this.isObjectEmpty(meta.lossCoverage) ||
      meta.theftDamagesExcluded !== undefined ||
      meta.waterDamagesExcluded !== undefined
    );
  }

  isObjectEmpty = isObjectEmpty;
}
